module.exports = __webpack_public_path__ + "static/media/BrixSans-ExtraLight.8ca5d885.eot";